export default "__VITE_ASSET__Cx7W$cP0__"